import { BaseVariableProps } from "../EmailBuilderTypes";
import VariableCollapse from "./VariableCollapse";

const RecordValueBuilder = ({
  variable,
  setVariables,
  index,
  customVariables,
  expandAll,
}: BaseVariableProps) => {
  const Builder = <></>;

  return (
    <VariableCollapse
      variable={variable}
      setVariables={setVariables}
      index={index}
      customVariables={customVariables}
      expandAll={expandAll}
    >
      {Builder}
    </VariableCollapse>
  );
};

export default RecordValueBuilder;
